<template>
    <el-menu
        :default-active="$route.path"
        class="el-menu-vertical-demo"
        background-color="#47517a"
        text-color="#ffffff"
        active-text-color="#ffffff"
        @open="handleOpen"
        @close="handleClose"
    >
      <template v-for="(pm,index) of menus" :key="index">
        <el-sub-menu :index="index" v-if="pm.groupName">
          <template #title>{{pm.groupName}}</template>
          <el-menu-item v-for="(cm,cindex) of pm.children" :index="cm.fullPath" @click="goPage(cm.fullPath)">{{cm.meta.title}}</el-menu-item>
        </el-sub-menu>
        <el-menu-item v-else :index="pm.fullPath" @click="goPage(pm.fullPath)">{{pm.meta.title}}</el-menu-item>
      </template>
    </el-menu>
</template>

<script setup>
// import { ArrowDown } from '@element-plus/icons-vue'
import {computed,onMounted,watch,ref} from "vue"
import {routesS} from "@/router/studentRouter"
import {routesSP} from "@/router/speciaRouter"
import {routesAd} from "@/router/adminRouter"
import { useRouter } from 'vue-router';
const router= useRouter()
import {useStore} from "vuex";
const store = useStore()
const auth =  computed(() => store.state.loginModel.role)
const currentRouter = computed(()=>store.state.sysModel.currentRouter)
const menus = ref([])
//admin、special、students
watch(() => store.state.loginModel.auth,(now, prev)=>{
  getMenu && getMenu(now)
})
onMounted(()=>{
  getMenu(auth.value)
})
const handleOpen = ()=>{

}
const handleClose = ()=>{

}
// 获取菜单
const getMenu = (role)=>{
  if(!role){
   return menus.value = []
  }
//  处理菜单
  let oriMenu = [],path = "/"
  if(role==="admin"){
    oriMenu = routesAd
  }else if(role==="special"){
    oriMenu = routesSP
  }else if(role==="students"){
    oriMenu = routesS
  }
  // 子菜单
  const list = oriMenu.children || []
  path = oriMenu.path
  const arr = []
//   处理菜单分组，找出所有分组
  list.forEach(item=>{
    if(!item.meta.menuShow){
      return
    }
    if(item.meta.group){
      const index = arr.findIndex(l=>l.groupName == item.meta.group)
      if(index>-1){
        arr[index].children.push({...item,fullPath:`${path}/${item.path}`})
      }else{
        arr.push({
          groupName:item.meta.group,
          children:[{...item,fullPath:`${path}/${item.path}`}]
        })
      }
    }else{
      arr.push({...item,fullPath:`${path}/${item.path}`})
    }
  })
  menus.value = arr
}
// 跳转
const goPage = (path)=>{
  router.push({
    path: path
  })
}

</script>

<style scoped lang="scss">
.menu-box{
  width: 100%;
}

</style>
